<template>
  <div class="container grid-default py-6 lg:py-24">
    <div class="col-span-6 lg:col-span-6">
      <Heading
        v-if="data.title"
        :semantic="isSemantic"
        :level="level"
        class="mb-4 text-5xl font-light text-blue lg:mb-0 lg:text-9xl"
      >
        {{ data.title }}
      </Heading>
    </div>
    <div
      v-if="data.html"
      class="col-span-6 text-base text-neutral-500 lg:text-2xl"
      v-html="data.html"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { useAppStore } from '~/stores/AppStore'
import type { SectionTitleRecord } from '~/types/generated'
const store = useAppStore()

const props = defineProps({
  data: {
    type: Object as PropType<SectionTitleRecord>,
    default: () => {}
  },
  index: {
    type: Number,
    required: true
  }
})

const { level, isSemantic } = useSectionRules(props.index, !!props.data.title)

onMounted(() => {
  store.setTheme('white')
})
</script>
